import { defaultDocumentType } from './regions';

/* eslint-disable no-use-before-define */
export const getErrorMessage = (code) => {
  const msgFound = ERROR_MESSAGES.find((obj) => obj.CODE === code);
  return msgFound ? msgFound.MESSAGE : code; // "Algo salió mal, vuelve a intentarlo más tarde";
};
export const getErrorId = (code) => {
  const msgFound = ERROR_MESSAGES.find((obj) => obj.CODE === code);
  return msgFound ? msgFound.ID : ''; // "Algo salió mal, vuelve a intentarlo más tarde";
};
const ERROR_MESSAGES = [
  {
    CODE: 'Merchant not found',
    MESSAGE: 'El email o la contraseña son incorrectos',
  },
  {
    CODE: "Cannot read property 'doc_number' of null",
    MESSAGE: 'Su usuario ha sido mal creado, por favor contactese con servicio técnico',
  },
  {
    CODE: 'Password invalid',
    MESSAGE: 'No uses tu número de documento o teléfono en la contraseña',
  },
  {
    CODE: "Error generate JWT: Cannot read property 'status' of undefined",
    MESSAGE: 'Algo salió mal, vuelve a intentarlo más tarde',
  },
  {
    CODE: 'Error generate JWT: Invalid Access',
    MESSAGE: 'Algo salió mal, vuelve a intentarlo más tarde',
  },
  {
    CODE: 'error saving password',
    MESSAGE: 'Ha ocurrido un error al querer guardar el password',
  },
  {
    CODE: 'Terms and conditions must be accepted',
    MESSAGE: 'Debes aceptar los términos y condiciones para continuar',
  },
  {
    CODE: 'This email is already registered',
    MESSAGE: 'Ya existe una cuenta creada con ese email',
    ID: 'onb-representantForm-email',
  },
  {
    CODE: 'this email is invalid',
    MESSAGE: 'Ya existe una cuenta creada con ese email',
    ID: 'onb-representantForm-email',
  },
  {
    CODE: 'the email is invalid',
    MESSAGE: 'El email ingresado no es válido',
    ID: 'onb-representantForm-email',
  },
  {
    CODE: 'Error updating qr data: Request failed with status code 404',
    MESSAGE: 'Algo salió mal, vuelve a intentarlo más tarde',
  },
  {
    CODE: 'Short code is not available',
    MESSAGE: 'El ID ingresado ya fue vinculado, intenta con uno diferente',
  },
  {
    CODE: 'Error getting qr: Request failed with status code 404',
    MESSAGE: 'Algo salió mal, vuelve a intentarlo más tarde',
  },
  {
    CODE: 'Error getting customer and account: Api core transaction service error: timeout of 7000ms exceeded',
    MESSAGE: 'Algo salió mal, vuelve a intentarlo más tarde',
  },
  {
    CODE: 'Error remove session Request failed with status code 404',
    MESSAGE: 'Algo salió mal, vuelve a intentarlo más tarde',
  },
  {
    CODE: 'Invalid credentials.',
    MESSAGE: 'El email o la contraseña son incorrectos',
  },
  {
    CODE: 'Invalid Credentials',
    MESSAGE: 'El email o la contraseña son incorrectos',
  },

  {
    CODE: 'Address error: ADMINISTRATIVE_AREA_LEVEL_3_REQUIRED',
    MESSAGE: 'Para continuar, es necesario que ingreses la dirección completa en el paso anterior',
  },
  {
    CODE: 'Access invalid',
    MESSAGE: 'No tiene permiso para realizar esta acción',
  },
  {
    CODE: 'Invalid rut',
    MESSAGE: 'Ya existe una cuenta creada con ese rut',
  },
  {
    CODE: 'Error document: This document number is not enable.',
    MESSAGE: 'Ya existe una cuenta creada con ese rut',
  },
  {
    CODE: `Invalid ${defaultDocumentType.toLowerCase()}`,
    MESSAGE: `Ya existe una cuenta creada con ese ${defaultDocumentType.toLowerCase()}`,
  },
  {
    CODE: 'This email not is allowed',
    MESSAGE: 'El email con el que intentas ingresar se encuentra deshabilitado',
  },
  {
    CODE: 'Error, the field address_info have a max of 100 characters allowed.',
    MESSAGE: 'Debe tener un máximo de 100 caracteres',
  },
  {
    CODE: 'La cuenta ingresada no es válida, revisa los datos y vuelve a intentarlo',
    MESSAGE: 'La cuenta ingresada no es válida, revisa los datos y vuelve a intentarlo',
    ID: 'error-invalid-bank-account',
  },
  // TODO: Al tener los codigos
  // {CODE:"Error: the document number 24.082.633-K does not belong to merchant", MESSAGE: 'El rut ingresado no coincide con el rut del comercio'}
];
